import { useEffect, useState } from 'react';
import { FunctionComponent } from 'react';
import './freetrial-form.scss';
import { produce } from 'immer';
import { GetLanguageLabel } from '../shared/tools';
import DIV from '../shared/html-tags/div';
import LABEL from '../shared/html-tags/label';
import { s } from 'framer-motion/dist/types.d-6pKw1mTI';
import { useNavigate } from 'react-router-dom';

export type Props = { source: string };

const FreeTrialForm: FunctionComponent<Props> = (props) => {
  const [caseCreated, setCaseCreated] = useState<boolean>(false);
  const [firstName, setFirstName] = useState<string | undefined>(undefined);
  const [lastName, setLastName] = useState<string | undefined>(undefined);
  const [emailAddress, setEmailAddress] = useState<string | undefined>(undefined);

  const [dataPrivacyAccepted, setDataPrivacyAccepted] = useState<string>('');
  // Define the API URL and the endpoint for creating a case
  const apiUrl = 'https://crm.2x4.de/api/v1/LeadCapture/49c02bb584116cbd72e8bba873de07bb';

  // ----------------------------------------------------------------
  async function createCase() {
    // ----------------------------------------------------------------
    //console.log(data);

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstName: firstName ?? '',
          lastName: lastName ?? '',
          emailAddress: emailAddress ?? '',
          description: '',
          user1: dataPrivacyAccepted,
          datasource: props.source,
          language: 'German',
          topics: ['PS Imago Pro'],
          cLeadType: 'FreeTrial',
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      } else {
        setCaseCreated(true);
        // Redirect to the success page
        setTimeout(() => {
          window.location.href = '/de/freetrial-success';
        }, 1);
      }
    } catch (error) {
      console.error('Error creating case:', error);
    }
  }

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <div className="form">
      {!caseCreated && (
        <>
          {/* ======================================================================================== */}
          <div className="form-line">
            <DIV language="de" className="form-label">
              Dein Name
            </DIV>
            <DIV language="en" className="form-label">
              Your Name
            </DIV>
            <div className="form-input">
              <input
                className="half-width"
                type="text"
                placeholder={GetLanguageLabel([
                  { language: 'de', label: 'Vorname' },
                  { language: 'en', label: 'First Name' },
                ])}
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.currentTarget.value);
                }}
              ></input>
              <input
                className="half-width"
                type="text"
                placeholder={GetLanguageLabel([
                  { language: 'de', label: 'Nachname' },
                  { language: 'en', label: 'Last Name' },
                ])}
                value={lastName}
                onChange={(e) => {
                  setLastName(e.currentTarget.value);
                }}
              ></input>
            </div>
          </div>

          {/* ======================================================================================== */}
          <div className="form-line">
            <DIV language="en" className="form-label">
              Email
            </DIV>
            <DIV language="de" className="form-label">
              E-Mail
            </DIV>
            <div className="form-input">
              <input
                className="full-width"
                type="email"
                placeholder={GetLanguageLabel([
                  { language: 'de', label: 'Deine berufliche E-Mail Adresse' },
                  { language: 'en', label: 'Your Company Email' },
                ])}
                value={emailAddress}
                onChange={(e) => {
                  setEmailAddress(e.currentTarget.value);
                }}
              ></input>
            </div>
          </div>

          {/* ======================================================================================== */}
          <div className="form-line">
            <div className="form-label"></div>
            <div className="form-input form-privacy">
              <input
                id="privacy"
                type="checkbox"
                checked={dataPrivacyAccepted !== ''}
                onChange={(e) => {
                  setDataPrivacyAccepted(
                    e.currentTarget.checked ? 'Policy Accepted: ' + new Date() : ''
                  );
                }}
              ></input>
              <LABEL language="de" htmlFor="privacy">
                Ich stimme zu, daß meine personenbezogenen Daten gemäß der{' '}
                <a href="/privacy" target="_blank">
                  Datenschutzerklärung
                </a>{' '}
                erhoben und verarbeitet werden.
              </LABEL>
              <LABEL language="en" htmlFor="privacy">
                I accept that the data above will be processed and stored according to the
                SurveyTester{' '}
                <a href="/privacy" target="_blank">
                  Privacy Policy
                </a>
              </LABEL>
            </div>
            <div style={{ marginTop: '1.5rem' }}>
              <p style={{ fontSize: '0.8rem' }}>
                Du kannst die Testversion 14 Tage lang ausgiebig testen und neue Erkentnisse
                gewinnen. Danach wird die Software automatisch auf Deinem PC deaktiviert.
              </p>
              <p style={{ fontSize: '0.8rem' }}>
                Nachdem du den Button „Kostenlose Testversion anfordern“ geklickt hast, erhältst du
                eine E-Mail mit dem Download-Link.
              </p>
            </div>
          </div>
          <div className="form-line">
            <div className="form-label"></div>
            <div className="form-send">
              <input
                type="button"
                value={GetLanguageLabel([
                  { language: 'de', label: 'Kostenlose Testversion anfordern' },
                  { language: 'en', label: 'Request free trial' },
                ])}
                onClick={() => {
                  createCase();
                }}
                disabled={!(emailAddress && firstName && lastName && dataPrivacyAccepted !== '')}
              ></input>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FreeTrialForm;
